import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sentiment-details-trend-cohort-card',
  standalone: false,
  templateUrl: './details-trend-cohort-card.component.html',
  styleUrls: ['./details-trend-cohort-card.component.scss'],
})
export class SentimentDetailsTrendCohortCardComponent {
  @Input() activeTab: 'trend' | 'cohort' = 'trend';
  @Input() timePeriod = 'quarterly';
  @Input() timePeriodOptions: ReadonlyArray<{ value: string; label: string }> = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'yearly', label: 'Yearly' },
  ];
  /** Cohort tab: dropdown value (gender, interactionType, ageGroup) – must match parent so table and dropdown stay in sync. */
  @Input() cohortFilter = 'interactionType';
  /** Cohort tab: dropdown options (Gender, Interaction Type, Age Group). */
  @Input() cohortFilterOptions: ReadonlyArray<{ value: string; label: string }> = [];
  @Output() activeTabChange = new EventEmitter<'trend' | 'cohort'>();
  @Output() timePeriodChange = new EventEmitter<string>();
  @Output() cohortFilterChange = new EventEmitter<string>();

  setTab(tab: 'trend' | 'cohort'): void {
    this.activeTabChange.emit(tab);
  }

  onPeriodChange(value: string): void {
    this.timePeriodChange.emit(value);
  }

  onCohortFilterChange(value: string): void {
    this.cohortFilterChange.emit(value);
  }
}
